<!--
 * @Author: cn1994
 * @Date: 2023-08-23 10:21:54
 * @LastEditors: cn1994
 * @LastEditTime: 2024-05-27 12:07:13
 * @Description: 预览图顶部导航区组件
-->
<template>
  <div class="ls-nav-component">
    <div class="center">
      <div
        v-for="item in topConfig"
        :key="item.id"
        v-if="item.hasHide == 'false'"
        class="nav-item"
      >
        <img class="icon" :src="item.logoUrl">
        <span class="title" :style="getStyles(item)">{{ getSubassemblyTitle(item) }}</span>
      </div>
    </div>
    <div class="right" v-if="role != 'student'">
      <div class="nav-item">
        <img class="icon" src="https://cdnws.51tyty.com/lstyty/file/2023/08/22/250c47e0537713b39579becdb08485dd.png">
        <span class="title">消息</span>
      </div>
      <div class="nav-item">
        <img class="icon" src="https://cdnws.51tyty.com/lstyty/file/2023/08/22/2bf00b87fcdbf9720da2ca1cd81c304a.png">
        <span class="title">设置</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topConfig: {
      type: Array,
      default: []
    },
    role: {
      type: String,
    }
  },
  methods: {
    getStyles(data) {
      if (this.role == 'student') {
        return ''
      } else {
        return {
          'background-image': `url(${data.backgroundUrl})`,
          'background-repeat': 'no-repeat',
          'background-size': '100% 100%',
          'padding': '2px 5px',
        }
      }
    },
    getSubassemblyTitle(data) {
      if(data.subassemblyTitle) {
        if (data.subassemblyTitle[0].title.trim() == '') {
          return data.subassemblyTitle[0].defaultTitle
        } else {
          return data.subassemblyTitle[0].title
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ls-nav-component {
  display: flex;
  flex-direction: row;
  align-items: center;
  .center {
    display: flex;
    flex-direction: row;
    align-items: center;
    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 24px;
      .icon {
        width: 40px;
        height: 40px;
      }
      .title {
        font-size: 12px;
        color: #1D2129;
        line-height: 17px;
        margin-top: 4px;
        word-break: keep-all;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 60px;
        white-space: nowrap;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 24px;
      .icon {
        width: 40px;
        height: 40px;
      }
      .title {
        font-size: 12px;
        color: #1D2129;
        line-height: 17px;
        margin-top: 4px;
        word-break: keep-all;
      }
    }
  }
}
</style>